<script setup>
import RcIcon from '@components/RcIcon/RcIcon.vue';

const props = defineProps({
  accordions: {
    type:     Array,
    required: true,
  }
});

const handleScrollTo = (entry, event) => {
  entry?.scrollTo?.();
  event?.currentTarget?.blur?.();
};
</script>

<template>
  <div class="toc-root">
    <div class="toc-container">
      <h4>
        {{ t('cruResource.tableOfContents.jumpTo') }}
      </h4>
      <ul>
        <li
          v-for="(acc, i) in props.accordions"
          :key="i"
          :data-testid="`toc-list-item-${i}`"
        >
          <button
            v-if="acc.scrollTo"
            type="button"
            class="btn role-link accordion-link toc-parent-link"
            @click="handleScrollTo(acc, $event)"
          >
            <span>{{ acc.label }}</span>
            <RcIcon
              v-if="acc.invalid"
              v-clean-tooltip="t('component.rcSection.invalidFields')"
              type="error"
              size="small"
              status="error"
              data-testid="toc-invalid-fields"
            />
          </button>
          <span v-else>{{ acc.label }}</span>
          <template v-if="acc?.children?.length">
            <ul data-testid="toc-list">
              <li
                v-for="(childAcc, j) in acc.children"
                :key="j"
                :data-testid="`toc-list-item-${i}-${j}`"
              >
                <button
                  v-if="childAcc.scrollTo"
                  type="button"
                  class="btn role-link accordion-link toc-child-link"
                  @click="handleScrollTo(childAcc, $event)"
                >
                  <span>{{ childAcc.label }}</span>
                  <RcIcon
                    v-if="childAcc.invalid"
                    v-clean-tooltip="t('component.rcSection.invalidFields')"
                    type="error"
                    size="small"
                    status="error"
                    data-testid="toc-invalid-fields"
                  />
                </button>
                <span v-else>{{ childAcc.label }}</span>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li:not(:last-child) {
    margin-bottom: var(--gap);
  }

  h4 {
    margin-bottom: 12px;
    margin-top: 0px
  }

  li ul {
    padding-left: var(--gap-md);
    & li {
      margin-top: var(--gap);
      margin-bottom: 0px;
    }
  }

  .toc-container {
    padding: var(--gap-md);
    border-radius: var(--border-radius);
    background-color: var(--subtle-overlay-bg);
  }

  .accordion-link {
    padding: 0px;
    min-height: 0px;
    line-height: 1.3em;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    text-align: left;
    display: flex;
    align-items: center;
    gap: var(--gap);
    width: 100%;
  }

  li > span {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    display: block;
  }

  .toc-parent-link {
    font-weight: 700;
  }
</style>
